import React, {createContext, useEffect, useState} from 'react';
import {useEventListener} from "primereact/hooks";

export interface KeyboardContextType {
    pressedKeysState: Record<string, boolean>
}

export const KeyboardContext = createContext<KeyboardContextType>({} as KeyboardContextType);

export const KeyboardContextProvider = (props: any) => {
    const [pressedKeysState, setPressedKeysState] = useState<Record<string, boolean>>({});

    const onKeyDown = (e: KeyboardEvent) => {
        setPressedKeysState(prevState => {
            return {...prevState, [e.code]: true}
        })
    };

    const onKeyUp = (e: KeyboardEvent) => {
        setPressedKeysState(prevState => {
            return {...prevState, [e.code]: false}
        })
    }

    const [bindKeyDown, unbindKeyDown] = useEventListener({
        type: 'keydown',
        listener: onKeyDown
    });

    const [bindKeyUp, unbindKeyUp] = useEventListener({
        type: 'keyup',
        listener: onKeyUp
    });

    useEffect(() => {
        bindKeyDown();
        bindKeyUp();

        return () => {
            unbindKeyDown();
            unbindKeyUp();
        };
    }, [bindKeyDown, bindKeyUp, unbindKeyDown, unbindKeyUp]);


    return <>
        <KeyboardContext.Provider value={{pressedKeysState}}>
            {props.children}
        </KeyboardContext.Provider>
    </>
};
